(() => {
  const trademark = '\u2122';
  const excludedParents = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE', 'TEXTAREA', 'OPTION', 'SUP']);

  function replaceTrademark(textNode) {
    if (!textNode.nodeValue?.includes(trademark)) return;

    const parent = textNode.parentElement;
    if (!parent || excludedParents.has(parent.tagName)) return;

    const parts = textNode.nodeValue.split(trademark);
    const fragment = document.createDocumentFragment();

    parts.forEach((part, index) => {
      if (part) fragment.append(document.createTextNode(part));

      if (index < parts.length - 1) {
        const superscript = document.createElement('sup');
        superscript.textContent = 'TM';
        fragment.append(superscript);
      }
    });

    textNode.replaceWith(fragment);
  }

  function process(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      replaceTrademark(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
    if (root.nodeType === Node.ELEMENT_NODE && excludedParents.has(root.tagName)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(replaceTrademark);
  }

  process(document.body);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        process(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(process);
    });
  });

  observer.observe(document.body, {
    childList: true,
    characterData: true,
    subtree: true,
  });
})();
